import { render, staticRenderFns } from "./RequestRoads.vue?vue&type=template&id=5a3b3abb&scoped=true&"
import script from "./RequestRoads.vue?vue&type=script&lang=js&"
export * from "./RequestRoads.vue?vue&type=script&lang=js&"
import style0 from "./RequestRoads.vue?vue&type=style&index=0&id=5a3b3abb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3b3abb",
  null
  
)

export default component.exports
import {QToolbar,QToolbarTitle,QCardActions,QBtn,QTooltip,QSeparator,QCard,QCardSection} from 'quasar'
component.options.components = Object.assign({QToolbar,QToolbarTitle,QCardActions,QBtn,QTooltip,QSeparator,QCard,QCardSection}, component.options.components || {})
